import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Formatter, StringCompare } from '@stamhoofd/utility';
import { v4 as uuidv4 } from "uuid";
import { Address } from "../addresses/Address";
import { ParentType } from "./ParentType";
export class Parent extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.type = ParentType.Mother;
        this.firstName = "";
        this.lastName = "";
        this.phone = null;
        this.email = null;
        this.address = null;
    }
    get name() {
        if (!this.firstName) {
            return this.lastName;
        }
        if (!this.lastName) {
            return this.firstName;
        }
        return this.firstName + " " + this.lastName;
    }
    matchQuery(query) {
        if (StringCompare.typoCount(this.firstName, query) < 2 ||
            StringCompare.typoCount(this.lastName, query) < 2 ||
            StringCompare.typoCount(this.name, query) < 2) {
            return true;
        }
        return false;
    }
    /**
     * Call this to clean up capitals in all the available data
     */
    cleanData() {
        var _a;
        if (StringCompare.isFullCaps(this.firstName)) {
            this.firstName = Formatter.capitalizeWords(Formatter.removeDuplicateSpaces(this.firstName.toLowerCase()));
        }
        if (StringCompare.isFullCaps(this.lastName)) {
            this.lastName = Formatter.capitalizeWords(Formatter.removeDuplicateSpaces(this.lastName.toLowerCase()));
        }
        if (this.email) {
            this.email = this.email.toLowerCase().trim();
        }
        if (this.phone) {
            this.phone = Formatter.removeDuplicateSpaces(this.phone.trim());
        }
        this.firstName = Formatter.capitalizeFirstLetter(Formatter.removeDuplicateSpaces(this.firstName.trim()));
        this.lastName = Formatter.removeDuplicateSpaces(this.lastName.trim());
        if (this.lastName === this.lastName.toLocaleLowerCase()) {
            // Add auto capitals
            this.lastName = Formatter.capitalizeWords(this.lastName);
        }
        (_a = this.address) === null || _a === void 0 ? void 0 : _a.cleanData();
    }
    isEqual(other) {
        var _a, _b;
        this.cleanData();
        other.cleanData();
        return this.firstName === other.firstName && this.lastName === other.lastName && this.email === other.email && this.phone === other.phone && ((_a = this.address) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = other.address) === null || _b === void 0 ? void 0 : _b.toString());
    }
    merge(other) {
        if (other.firstName.length > 0) {
            this.firstName = other.firstName;
        }
        if (other.lastName.length > 0) {
            this.lastName = other.lastName;
        }
        if (other.email) {
            this.email = other.email;
        }
        if (other.address) {
            this.address = other.address;
        }
        if (other.phone) {
            this.phone = other.phone;
        }
        if (other.type) {
            if (other.type === ParentType.Parent1 || other.type === ParentType.Parent2) {
                // Ignore if current type is also not one of those
                if (this.type === ParentType.Parent1 || this.type === ParentType.Parent2) {
                    this.type = other.type;
                }
            }
            else {
                this.type = other.type;
            }
        }
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Parent.prototype, "id", void 0);
__decorate([
    field({ decoder: new EnumDecoder(ParentType) })
], Parent.prototype, "type", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Parent.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Parent.prototype, "lastName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Parent.prototype, "phone", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, field: "mail" }),
    field({ decoder: StringDecoder, nullable: true, version: 5 })
], Parent.prototype, "email", void 0);
__decorate([
    field({ decoder: Address, nullable: true })
], Parent.prototype, "address", void 0);
//# sourceMappingURL=Parent.js.map